<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="17">
                    <h2 >भुगतान क्यूआर </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='16'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUjhndQ-f8"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
                <div class="col-md-12 mt-2">

                    <label for="" class="mt-3" >पेमेंट क्यूआर के साथ, पेजी प्रौद्योगिकी
                        और सुविधा के बीच की खाई को पाट रहा है, जिससे आपके ग्राहकों को क्यूआर कोड की
                        शक्ति का उपयोग करके लेनदेन तेजी से और सुरक्षित रूप से पूरा करने की अनुमति
                        मिलती है। पेमेंट क्यूआर के साथ, हम भुगतान अनुभव को फिर से परिभाषित कर रहे
                        हैं, इसे पहले से कहीं अधिक तेज़, सुरक्षित और अधिक सहज बना रहे हैं। इससे कोई
                        फर्क नहीं पड़ता कि आप कहां हैं या क्या खरीद रहे हैं, हमारी भुगतान क्यूआर
                        सुविधा आपको लेनदेन को सहजता से पूरा करने में सक्षम बनाती है, जिससे
                        व्यापारियों और ग्राहकों दोनों के लिए एक सुरक्षित और कुशल प्रक्रिया सुनिश्चित
                        होती है। </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="18">
                    <h2 >क्यूआर भुगतान के मुख्य लाभ: </h2>
                    <ul>
                      <li class="mt-3" >
                            <b>त्वरित लेनदेन:</b>&nbsp; भुगतान क्यूआर एक साधारण स्कैन के साथ तेजी से
                            लेनदेन को सक्षम बनाता है।
                        </li>
                        <li class="mt-3" >
                            <b>उपयोगकर्ता के अनुकूल अनुभव:</b>&nbsp; पे जी के प्लेटफ़ॉर्म में सहजता
                            से एकीकृत, पेमेंट क्यूआर ग्राहकों और व्यापारियों दोनों के लिए उपयोगकर्ता
                            के अनुकूल अनुभव प्रदान करता है।
                        </li>
                        <li class="mt-3" >
                            <b> उन्नत सुरक्षा:</b>&nbsp;प्रत्येक क्यूआर कोड एन्क्रिप्टेड है, जो
                            सुरक्षित भुगतान प्रसंस्करण और संवेदनशील जानकारी की सुरक्षा सुनिश्चित
                            करता है।
                        </li>
                        <li class="mt-3" >
                            <b>कभी भी, कहीं भी भुगतान:</b>&nbsp; चाहे स्टोर में हो, इवेंट में हो या
                            ऑनलाइन, पेमेंट क्यूआर विभिन्न टचप्वाइंट पर भुगतान को सशक्त बनाता है।
                        </li>
                    </ul>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="19">
                    <h2 >भुगतान एकत्र करने के लिए अपने पे जी QR कोड से शुरुआत करें:
                    </h2>
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>चरण 1:</b> अपने पे जी मर्चेंट खाते में साइन इन
                        करें, यदि आप एक नए उपयोगकर्ता हैं तो अपने आप को पे जी के साथ पंजीकृत करें|
                    </label>
                    <br><img src="./assets/create1.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>चरण 2:</b> अपने मर्चेंट डैशबोर्ड पर, बाएं साइडबार
                        मेनू पर जाएं और "My QR Code" पर क्लिक करें। </label>
                    <br><img src="./assets/qr1.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>चरण 3:</b>व्यापारी इसे डाउनलोड कर सकते हैं और
                        भुगतान एकत्र करने के लिए अपने ग्राहकों के साथ साझा कर सकते हैं।
                        इसके अतिरिक्त, उनके पास अपने उत्पाद के आधार पर एक कस्टम राशि निर्धारित करने
                        की सुविधा है। </label>
                    <br><img src="./assets/qr2.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4   hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        विषयसूची:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
            <a href="#16"> <div class="row">


                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">

                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        What is a Payment QR </span>
                </div>
            </div></a>
        </div> -->

                <div class="col-md-12 mt-2">
                    <a href="#17">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')" >
                                    पेमेंट क्यूआर क्या है?</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#18">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')" >क्यूआर भुगतान के लाभ </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#19">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')" >शुरुआत कैसे करें? </span>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
             
                <a [routerLink]="['/pay-button']"> <button class="btn btn-color" (click)="menues('Pay Button')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पे बटन

                </button></a>
            </div>
            <div class="col-md-4    ">
            
                <a [routerLink]="['/invoice']"> <button class="btn btn-color" (click)="menues('Invoice')" >इनवॉइस
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>